import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-renewals-custom-contract-details',
  templateUrl: './renewals-custom-contract-details.component.html',
  styleUrls: ['./renewals-custom-contract-details.component.scss'],
})
export class RenewalsCustomContractDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
